export enum BoundsEnum {
    x = 0,
    y = 1,
    width = 2,
    height = 3
}
